import isEqual from 'lodash/isEqual';
import { flushAllPuckRichTextEditors } from './puckRichTextSyncRegistry';
import { getPuckHistory } from './puckHistoryRegistry';
import { notePuckHistory } from './webUndoTimeline';

// Puck 0.21 enregistre les changements après 250 ms, même après un blur.
const PUCK_HISTORY_DELAY = 250;
let checkpointId = 0;

export function checkpointRichTextHistory(history, appState) {
  if (!history || !appState) return;
  const current = history.histories[history.index];
  if (isEqual(current?.state.data, appState.data)) return;
  history.setHistories([
    ...history.histories.slice(0, history.index + 1),
    { id: `rich-text-before-${++checkpointId}`, state: appState },
  ]);
}

export async function flushRichTextHistory(getPuck) {
  await flushAllPuckRichTextEditors();
  const { history, appState } = getPuck();
  if (!isEqual(history.histories[history.index]?.state.data, appState.data)) {
    await new Promise((resolve) => setTimeout(resolve, PUCK_HISTORY_DELAY));
  }
  const latest = getPuck().history;
  if (getPuckHistory()?.undo === latest.back) {
    notePuckHistory(latest.back, latest.histories[latest.index]?.id, latest.index);
  }
}
